module.exports = __webpack_public_path__ + "ptc_momoro_P1.c3b5bbc6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/momoro/parent_to_child/ptc_momoro_P1.jpg
// module id = +AFX
// module chunks = 0